import React from 'react';

const TurnausInfo = () => {
  const paragraphStyle = {
    fontSize: '17px',
    lineHeight: '1.6',
    marginBottom: '16px',
  };

  const sectionTitleStyle = {
    fontSize: '20px',
    fontWeight: 'bold',
    marginTop: '24px',
    color:'#F0AE2E'
  };

  const sponsorLogoStyle = {
    width: '120px',
    height: 'auto',
    margin: '10px',
  };

  return (
    <div>
      <h2 style={{ textAlign: 'center' }}>🐺 Tervetuloa Susiluolaan!</h2>
      <h3 style={{ textAlign: 'center', color:'#F0AE2E' }}>AUTOSALPA-TURNAUS  </h3>
      <h4 style={{ textAlign: 'center', color:'#F0AE2E', marginTop:'0px' }}>17.–18.05.2025</h4>

      <div className="introduction" style={{ padding: '0 3px' }}>
        <p style={paragraphStyle}>
          <strong>Sipoon Wolf</strong> toivottaa kaikkia sydämellisesti tervetulleiksi U7/U8/U9-ikäluokkien jääkiekkoturnaukseen! Lauantaina ja sunnuntaina Susiluola täyttyy vauhdista ja kannustuksesta, kun nuoret pelaajat ottavat mittaa toisistaan jäällä.
        </p>

        <p style={sectionTitleStyle}>🏒 Luvassa huikeita pelejä ja hyvää fiilistä!</p>
        <p style={paragraphStyle}>
          Nauti tiukoista otteluista, mahtavista suorituksista ja kannusta oma joukkueesi voittoon!
        </p>

        <p style={sectionTitleStyle}>☕ 🍔 Herkkua koko perheelle</p>
        <p style={paragraphStyle}>
          Susikahvila tarjoaa suolaisia ja makeita herkkuja – ja grilli käy kuumana koko viikonlopun ajan!
        </p>

        <p style={sectionTitleStyle}>🎉 Oheisohjelmaa kaikenikäisille</p>
        <ul style={{ fontSize: '16px', lineHeight: '1.6',listStyleType: 'none',paddingLeft: '10px', marginLeft:'5px'
    }}>
          <li>🎟️ Arpajaiset</li>
          <li>🎡 Onnenpyörä</li>
          <li>🔥 Lämäritutka - kilpailu</li>
          <li>🏆 Gamechanger-kilpailu</li>
          <li>⛸️ Teroituspalvelu
                <br />
          <span style={{fontSize: '15px', paddingLeft: '10px'}}> (5€ / pari – puh: 0400959878)</span>
                  </li>
        </ul>

        <p style={sectionTitleStyle}>👨‍👩‍👧‍👦 Tule koko perheen voimin!</p>
        <p style={paragraphStyle}>
          Katsomossa on runsaasti tilaa, joten nappaa mukaan mummi, kummi ja kaverit — Tehdään tästä turnauksesta unohtumaton elämys!
        </p>

        <p style={sectionTitleStyle}>🤝 Lämmin kiitos sponsoreille!</p>
        <p style={paragraphStyle}>Sipoon Wolf U8/U9 kiittää tapahtuman tukijoita – ilman teitä tämä ei olisi mahdollista.</p>

        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
        <p
            style={{
              ...sponsorLogoStyle,
              fontSize: '18px',
              fontWeight: 'bold',
              color: 'white', // ensure text is visible on white background
              textAlign: 'center',
              width:'150px'
            }}
          >
            PRODESSENDUM OY
          </p>
          
          <img
            src='https://leipomosalonen.fi/wp-content/uploads/2021/07/Perheleipuri_Salonen_pysty_rgb.png'
            alt="salonen"
            style={sponsorLogoStyle}
          />
          <img
            src='https://www.cramo.fi/globalassets/cramo-finland/kuvat/cramo_rgb_1200x321.png'
            alt="cramo"
            style={sponsorLogoStyle}
          />
          <img
            src='https://www.autolasipojat.fi/wp-content/uploads/2020/02/lasipojat_pikkulogo_retina.png'
            alt="uudenmaan-autolasipojat"
            style={sponsorLogoStyle}
          />
          <img
            src='https://salonenoy.fi/wp-content/uploads/2024/12/psalonen-logo-sininen-8-500x222-2.png'
            alt="P-salonen Oy"
             style={{ ...sponsorLogoStyle, backgroundColor: 'white' }}
          />
           <img
            src='https://media.licdn.com/dms/image/v2/C4E12AQHCqbr9X7lA2A/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1520118778613?e=2147483647&v=beta&t=Gg-nlWCURccdj7iT1cV_-2DzAy50wKOs_FdQveB7ZmE'
            alt="Corrector Oy"
             style={{ ...sponsorLogoStyle, backgroundColor: 'white' }}
          />
          <img
            src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3mBIxJxoOPvfE97RGBiC6nmlmFxHAWQKMbQ&s'
            alt="autosalpa"
            style={{
              ...sponsorLogoStyle,
              width:'250px',
              height: 'auto'
            }
            }
          />
        </div>
        
        <p style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center', color:'#F0AE2E', }}>💙 Nähdään Susiluolassa!</p>
      </div>
    </div>
  );
};

export default TurnausInfo;
